import { PaginationRequestModel } from "../../../models";

/**
 * * Модель получения подзадач
 */
export class GetSubtasksModel {
  /**ID задачи */
  TaskId!: number;
  /**ID очереди */
  QueueTaskId!: string;
  /**Пагинация */
  Page!: PaginationRequestModel;

  constructor(obj?: Partial<GetSubtasksModel>) {
    Object.assign(this, obj);
  }
}
